import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    private readonly icons: string[] = [
        'bed',
        'bell',
        'building',
        'calendar_blank',
        'caret_up',
        'certificate',
        'chat',
        'certificate',
        'clockwise',
        'copy',
        'check_circle',
        'download',
        'envelope',
        'eye',
        'filled_star',
        'flip',
        'graduation_cap',
        'hand_coins',
        'identity_card',
        'info',
        'list',
        'magnify_glass',
        'map_pin',
        'mobile',
        'note',
        'open_new',
        'paper_plane_right',
        'paperclip',
        'pencil',
        'pdf',
        'receipt',
        'rotate_left',
        'rotate_right',
        'share',
        'student',
        'suitecase',
        'three_dots_vertical',
        'trash',
        'user',
        'user_circle',
        'warning_circle',
        'youtube',
        'upload',
        'back',
        'pencil_sharp',
        'reply',
        'plus',
    ];

    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer,
    ) {
        this.registerIcons();
    }

    private registerIcons(): void {
        this.icons.forEach((icon) => {
            // Safe bypass: icon names come from the hardcoded allowlist above; URLs point to same-origin static SVG assets only. Required by MatIconRegistry.addSvgIcon.
            this.iconRegistry.addSvgIcon(
                icon,
                this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`), // NOSONAR
            );
        });
    }
}
